import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

export type StyledMessageProps = {
  isCustomerMessage: boolean;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 3rem;
`;

const Content = styled.div<StyledMessageProps>`
  align-self: ${({ isCustomerMessage }) => (isCustomerMessage ? 'flex-start' : 'flex-end')};

  width: 26rem;
  padding: 1.7rem 1.5rem;

  background-color: ${({ isCustomerMessage }) =>
    pickColor(isCustomerMessage ? 'message' : 'messageSecondary')};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const Time = styled(Headline)<StyledMessageProps>`
  align-self: ${({ isCustomerMessage }) => (isCustomerMessage ? 'flex-start' : 'flex-end')};

  margin-top: 0.8rem;
  ${({ isCustomerMessage }) =>
    isCustomerMessage
      ? css`
          margin-left: 0.8rem;
        `
      : css`
          margin-right: 0.8rem;
        `}
`;

export { Container, Content, Time };
